import { HTMLAttributes } from "react";

import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    root: {
        padding: "0 24px 24px",
        fontSize: "16px",
        fontWeight: 400,
        color: "#4A4A4A",

        [theme.breakpoints.down(500)]: {
            padding: "0 16px 24px",
        },

        "& > *": {
            marginTop: 0,
            marginBottom: "16px",

            "&:last-child": {
                marginBottom: 0,
            },
        },

        "& > ul": {
            marginTop: "-16px",

            "&:first-child": {
                marginTop: 0,
            },
        },
    },
}));

export const AlternativeCardContent = (props: HTMLAttributes<HTMLDivElement>) => {
    const classes = useStyles();

    const { className, ...otherProps } = props;

    return (
        <div className={className ? `${classes.root} ${className}` : classes.root} {...otherProps} />
    );
};
